import { render, staticRenderFns } from "./EditOpening.vue?vue&type=template&id=9586feca&scoped=true"
import script from "./EditOpening.vue?vue&type=script&lang=js"
export * from "./EditOpening.vue?vue&type=script&lang=js"
import style0 from "./EditOpening.vue?vue&type=style&index=0&id=9586feca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9586feca",
  null
  
)

export default component.exports